// eslint-disable-next-line import/prefer-default-export
export const getLeaderships = (state) => (state.leaderships.leaderships);
export const getErrorMessage = (state) => (state.leaderships.errorMessage);
